import intl from 'react-intl-universal';
import { ReactNode } from 'react';
import Icon from '@/components/Icon';
import { isObject } from 'lodash';
import { isGlobalEnv } from '@/config';

export const systemMenuIcons: { [key: string]: ReactNode } = {
    '/index': <Icon type="icon-gongzuotai" />,
    '/kfgl': <Icon type="icon-directionsferry" />,
    '/xtsz': <Icon type="icon-daoju" />,
    '/djzx': <Icon type="icon-guangyuelou" />,
    '/wdgd': <Icon type="icon-gongdan" />,
    '/outer/im': <Icon type="icon-zaixianzixun" />,
    '/outer/chat:record:view': <Icon type="icon-lishijilu" />,
    '/order/index': <Icon type="icon-guangyuelou" />,
    '/park/index': <Icon type="icon-ertongfang" />,
    '/member': <Icon type="icon-kehuzhongxin" />,
    '/tools': <Icon type="icon-wangyuelou" />,
};

export const commonRules = {
    mobileLength: isGlobalEnv ? 20 : 11,
    remarkLength: 500,
    maxFileSize: 300, // 单位 M
    mobile: isGlobalEnv
        ? [] // 海外不校验手机号格式
        : [
              {
                  // i18n-ignore
                  message: '请输入正确的手机号',
                  // pattern: /^1[3456789]\d{9}$/,
                  pattern: /^[1-9][0-9]{10}$/,
                  validateTrigger: 'onChange',
              },
          ],

    email: [
        {
            // i18n-ignore
            message: '请输入正确的邮箱',
            // pattern: /^1[3456789]\d{9}$/,
            pattern: /^\w+(-+.\w+)*@\w+(-.\w+)*.\w+(-.\w+)*$/,
            validateTrigger: 'onChange',
        },
    ],

    upload: [
        {
            // i18n-ignore
            message: '请检查是否所有附件都上传成功',
            validator: (_: any, value: any[]) => {
                console.log(value);
                if (
                    value?.length &&
                    value.find(
                        (item: any) => isObject(item) && item.status !== 'done',
                    )
                ) {
                    return Promise.reject();
                }
                return Promise.resolve();
            },
        },
    ],
};

// 物流 - 寄回方式 - 选择自行寄回时提示文案
export const selfReturnTip = () =>
    intl.get('请注意：支持上门取件地区，请勿选择自行寄回');
